import { getDisplayColumns } from '../../utils/commonUtil';
import { tableColumns, sbColumns, actionColumns } from '../../components/Shared/Tabs/BrowserTab/BrowserTableStructure';
// Slice
export const DATATABLE_SLICE = 'displaySbDataTable';
export const DATATABLE_INITIAL_STATE: SbDataTableState = {
  isBrowserDataLoading: false,
  errorMessage: '',
  SbBrowserData: [],
  total_records: 0,
  records_offset: 0,
  paginationData: {
    rowPerPage: 100,
    page: 1,
    start: 0,
    end: 0,
    selectedChunkData: [],
  },
  columns: getDisplayColumns([...actionColumns, ...tableColumns, ...sbColumns]),
  FilterData: [],
  FilterState: [],
  FilterPayload: [],
  isColumnDataLoading: false,
  concurrentToggle: false,
  sbStatusViewToggle: false,
  browserTableClfState: {
    id_aircraft_registration: {},
    ata_4d: {},
    mod_reference: {},
    sb_reference: {},
    sb_status: {},
    sb_reporting_date: {},
    sb_classification: {},
    sb_function: {},
    configuration_number: {},
    mp_reference: {},
    mod_title: {},
    sb_title: {},
    alert: {},
    mp_title: {},
    operator_code_icao: {},
  },
  isAtaLoading: false,
  isModLoading: false,
  isSbReferenceLoading: false,
  isSbStatusLoading: false,
  isSbReportingDateLoading: false,
  isSbClassificationLoading: false,
  isSbFunctionLoading: false,
  isConfigurationNumberLoading: false,
  isMpReferenceLoading: false,
  isModTitleLoading: false,
  isSbTitleLoading: false,
  isAlertLoading: false,
  isMpTitleLoading: false,
};
export const LOAD_SB_DATA = 'loadSbBrowseData';
export const LOAD_FILTER_DATA = 'loadSbFilterData';
export const LOAD_SB_CLF_DATA = 'loadSbClfData';
export const SB_DATA_ERROR = 'Unable to get SB Browser Data';
